// A coluna Status Pedido da lista segue o BSeller, não o tabelão (Adnéia, 27/10/2026).
// O backend (routes/lista_rastreio.py) guarda de 15 em 15 min o ponto atual de cada atendimento
// pendente e já entrega status_pedido e data_ultimo_status com o BSeller quando a foto tem até
// 2 horas. Aqui só se diz de onde veio: status_pedido_fonte 'bseller' ou 'tabelao' e, no
// tabelão, o porquê (bseller_motivo). Sem status_pedido_fonte (backend antigo), nada muda.
// Status do BSeller sem data do ponto: a data é a do tabelão (data_status_fonte 'tabelao',
// decisão dela de 28/10), e a linha diz isso em cinza, porque é a data de outro status.

// '2026-10-27T22:15:00+00:00' -> '27/10 19:15' (Brasília); '' se não der.
export function horaConsultaBR(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  const p = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(d).reduce((acc, x) => ({ ...acc, [x.type]: x.value }), {});
  return `${p.day}/${p.month} ${p.hour}:${p.minute}`;
}

// { marca, titulo, alerta, planilha }: marca = texto pequeno embaixo do status ('' = nenhum);
// alerta = pendente sem o BSeller (laranja); planilha = a coluna "Fonte do Status" da exportação.
export function fonteStatusLista(atd) {
  const fonte = atd && atd.status_pedido_fonte;
  const hora = horaConsultaBR(atd && atd.bseller_consultado_em);
  if (fonte === 'bseller') {
    const base = hora ? `Status do BSeller, consultado em ${hora}` : 'Status do BSeller';
    if (atd.data_status_fonte === 'tabelao') {
      return {
        marca: 'data do tabelão',
        titulo: `${base}. O BSeller não trouxe a data deste ponto: a data é a do tabelão, que pode ser de outro status`,
        alerta: false,
        planilha: hora ? `BSeller (${hora}); data do tabelão` : 'BSeller; data do tabelão',
      };
    }
    return {
      marca: '',
      titulo: base,
      alerta: false,
      planilha: hora ? `BSeller (${hora})` : 'BSeller',
    };
  }
  if (fonte !== 'tabelao') return { marca: '', titulo: '', alerta: false, planilha: '' };
  const pendente = !!(atd && atd.pendente);
  let porque;
  if (atd.bseller_motivo === 'nao_achou') {
    porque = `o BSeller não trouxe esta entrega${hora ? ` na consulta de ${hora}` : ''}`;
  } else if (atd.bseller_motivo === 'antiga') {
    porque = `a última resposta do BSeller tem mais de 2 horas${hora ? ` (${hora})` : ''}`;
  } else if (pendente) {
    porque = 'o BSeller ainda não foi consultado para esta entrega (a consulta roda de 15 em 15 min)';
  } else {
    porque = 'a consulta ao BSeller é só para os atendimentos pendentes';
  }
  return {
    marca: 'do tabelão',
    titulo: `Do tabelão, a cópia do banco, que pode estar atrasada: ${porque}`,
    alerta: pendente,
    planilha: 'tabelão',
  };
}
